import { render, staticRenderFns } from "./TableMaterials.vue?vue&type=template&id=75045458"
import script from "./TableMaterials.vue?vue&type=script&lang=js"
export * from "./TableMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports